import type { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { accountNumberRegex } from 'src/shared/regex';

export const accountNumberRule = (): Rule => {
  const { t } = useTranslation();

  return ({
    required: true,
    message: t('Please enter correct account number'),
    pattern: accountNumberRegex,
  });
};
